export default __webpack_public_path__ + "static/media/ban.5854767c.webp";